import axios from "axios";
export default class ProductService {
  getTrackAndTraceDataAPI(paras) {
    //Update by Harry at 20220308, VAL-9136, to adjust call api link to hqesmapi.dimerco.com            
    return axios
      .get(
          `https://hqesmapi.dimerco.com/TrackAndTraceAPI/V3NewAPIV2/CSP_ExternalWeb/getTrackandTraceShipmentData?KeyValue=${paras.KeyValue}`
          //`https://10.161.252.241:4080/TrackAndTraceAPI/V3NewAPIV2/CSP_ExternalWeb/getTrackandTraceShipmentData?KeyValue=${paras.KeyValue}`
          //`http://localhost:58949/CSP_ExternalWeb/getTrackandTraceShipmentData?KeyValue=${paras.KeyValue}`
      )
      .then((res) => res.data);    
  }
  ExistedGPS(paras) {
      //Update by Ziv at 20231122, VAL-12940, Enhance - Open Map to track GPS 
      return axios
          .get(
              `https://hqesmapi.dimerco.com/TrackAndTraceAPI/V3NewAPIV2/CSP_ExternalWeb/IsExistedGPSData?KeyValue=${paras.KeyValue}&PL=${paras.PL}`
              //`https://10.161.252.241:4080/TrackAndTraceAPI/V3NewAPIV2/CSP_ExternalWeb/IsExistedGPSData?KeyValue=${paras.KeyValue}&PL=${paras.PL}`
              //`http://localhost:58949/CSP_ExternalWeb/IsExistedGPSData?KeyValue=${paras.KeyValue}&PL=${paras.PL}`
          )
          .then((res) => res.data);
  }
  //Update by Ziv at 2023/12/6 VAL-13179 Add From Site for Tracking Log
  getGPSUrlWithKeyvalue(paras) {
      return axios
          .get(
              `https://hqesmapi.dimerco.com/TrackAndTraceAPI/V3NewAPIV2/CSP_ExternalWeb/GetGPSUrl?Keyvalue=${paras.KeyValue}&PL=${paras.PL}&FromSite=TandT`
              //`https://10.161.252.241:4080/TrackAndTraceAPI/V3NewAPIV2/CSP_ExternalWeb/GetGPSUrl?Keyvalue=${paras.KeyValue}&PL=${paras.PL}&FromSite=TandT`
              //`http://localhost:58949/CSP_ExternalWeb/GetGPSUrl?Keyvalue=${paras.KeyValue}&PL=${paras.PL}&FromSite=TandT`
          )
          .then((res) => res.data);
  }
  getTrackAndTraceList(searchValue = "", pageIndex = 1, pageSize = 5) {    
      return axios
        //.get(`http://localhost:53216/TrackAndTrace/getCargoTrackNTraceList?keyValue=${searchValue}&PageIndex=${pageIndex}&PageSize=${pageSize}&Paginator=true`
        .get(`api/TrackAndTrace/getCargoTrackNTraceList?keyValue=${searchValue}&PageIndex=${pageIndex}&PageSize=${pageSize}&Paginator=true`
        //.get(`https://home.dimerco.com//TrackAndTrace/getCargoTrackNTraceList?keyValue=${searchValue}&PageIndex=${pageIndex}&PageSize=${pageSize}&Paginator=true`
      )
      .then((res) => res.data);
  }
  getKeyValueWithProNo(paras) {
      return axios
          .get(
              `api/TrackAndTrace/getKeyValueWithProNo?ProNo=${paras}`
                  //`https://home.dimerco.com//TrackAndTrace/getKeyValueWithProNo?ProNo=${paras}`
          )
          .then((res) => res.data);
  }
  ShipmentPOMSForAnixter(KeyValue, ProNo) {
      return axios
          .get(
              `api/TrackAndTrace/ShipmentPOMSForAnixter?KeyValue=${KeyValue}&ProNo=${ProNo}`
              //`https://home.dimerco.com//TrackAndTrace/ShipmentPOMSForAnixter?KeyValue=${KeyValue}&ProNo=${ProNo}`
          )
          .then((res) => res.data);
  }
}
